import { useMutation, useQueryClient } from "@tanstack/react-query";

import { PROMOTION_CACHE_KEYS } from "./keys";

import { PromotionRepository } from "@/repositories/promotion";

const promotionRepository = new PromotionRepository();

export const useDeletePromotion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => promotionRepository.delete(id),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: PROMOTION_CACHE_KEYS.LISTS }),
  });
};
